import {trigger, transition, style, animate} from '@angular/animations';
import {Component, HostListener, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation, Renderer2, ElementRef, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatExpansionPanel} from '@angular/material/expansion';
import {MatSnackBar} from '@angular/material/snack-bar'
import { ApiService } from 'app/services/api.service';
import { SocketService } from 'app/services/socket.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, ViewportScroller } from '@angular/common';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import {DeviceDetectorService } from 'ngx-device-detector';
import { interval, Subscription, timer } from 'rxjs';
import { CountdownComponent } from '@ciri/ngx-countdown';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-passenger-digital-twin',
  templateUrl: './passenger-digital-twin.component.html',
  styleUrls: ['./passenger-digital-twin.component.css'],
})
export class PassengerDigitalTwinComponent implements OnInit, OnDestroy, AfterViewInit {
  isPortrait: boolean;
  @ViewChild('expansionPanel', {static: false}) expansionPanel: MatExpansionPanel;
  activeIndex = 0;
  overAllStatus = {
    'left_camera': true,
    'right_camera': true
  };
  shoppingExpand: boolean = false;
  etaExpand: boolean = false;
  boarding_msg = 'Boarding Started';
  gate_close = 0;
  // recallBoardingFlight: any = null;
  adClose: boolean = false;
  checkRolling: any = 'assets/images/checkrollingss.gif';
  childData: any = {};
  @Output() revertBack: EventEmitter<any> = new EventEmitter();
  @ViewChild("ratingscomponent", { read: TemplateRef, static: false }) ratingscomponent: TemplateRef<any>;
  @ViewChild('counter', { static: false }) counter: CountdownComponent;
  private timeoutId: any;
  videSrc: string = '';
  expand: boolean = true;
  scanCount: number = 0;
  spinner = false;
  adTimer: any;
  adSrc = '';
  adCounter: number = 1;
  countdowncount: number = 11;
  pc: RTCPeerConnection | null = null;
  videoContainer: HTMLVideoElement | null = null;
  restartTimeout: any = null;
  sessionUrl: any = '';
  queuedCandidates: any = [];
  offerData: any = null;
  streamUrl = 'https://stream.adr.avileap.com/webrtc/main/1037070/';
  timer: any = {s: 72000, mn: 0, hr: 0};
  mintimer: any = {s: 90000, mn: 0, hr: 0};
  mintimerHandler: any;
  showclose: boolean = false;
  thankingMsgCondition: boolean = false;
  thankingTimeCondition: boolean = false;
  thankYouMsg: string = 'Thank You!';
  flightData;
  flightNo: string;
  dataarray;
  data=[];
  camcahneg:boolean = true;
  ratingspinner:boolean = false
  callapi;
  callapi1;
  imageFlightCode: boolean = true;
  clicked: number = 0;
  ref: MatDialogRef<any>;
  ratingarray;
  rating;
  norating:boolean = true;
  ratingsent:boolean = false;
  datamessage = '';
  ratingname:string = '';
  engdis: boolean = true;
  paxsessionid;
  RatingComment:string = '';
  fromispotrait:boolean;
  verifyqr:boolean = false;
  iseng : boolean = true
  weblink = environment['weblink'];
  public config: SwiperConfigInterface = {
    slidesPerView: 'auto',
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: true,
    pagination: false
  };
  @ViewChild(SwiperComponent, { static: false }) componentRef?: SwiperComponent;
  public type: string = 'component';

  public disabled: boolean = false;
  slider:boolean = false
  slides = [1, 2];
  currentIndex = 0; 
  callwatchcount;
  direction: 'right' | 'left' ='right';
  Showalert:boolean = false;
  refreshvalue:boolean = false;
  langconfig;
  langcode;
  is_inpnrscreen:boolean = false;
  index='';
  indexr='';
  qrimage;
  @Input() demo:boolean;
  @Input() gateslist : any;
  @Input() gatesdata : any;
  @Input() index1 :any;
  @Input() videolink: any;
  @Input() dataarray1:any;
  @Input() nextgate : any;
  @Input() dummygatevalue:any;
  nextgatevalue;
  progresstimeout;
  resqrimage;
  typepreview;
  startplayingtimer;
  isDestroyed:boolean = false;
  devicetype;
  source;
  device;
  medium;

  constructor(private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private renderer: Renderer2, 
    private el: ElementRef, 
    private viewportScroller: ViewportScroller, 
    private socket: SocketService, 
    private snackBar: MatSnackBar, 
    public router: Router,
    private route: ActivatedRoute, 
    private date: DatePipe,
    private devicedetails: DeviceDetectorService
    ) {
      this.renderer.listen('document', 'click', this.ondocclick.bind(this));
      if(this.demo == undefined){
        this.demo = false;
      }else{
        this.demo = true;
      }
      if(this.gateslist){
      }else{
        this.isPortrait = window.innerHeight > innerWidth ? true : false;
        this.data= [];
        this.route.queryParams.subscribe(params => {
          if(params['gateno'] && !this.gateslist){
            this.flightNo = params['gateno'].toUpperCase();
          }
        });
        this.paxsessionid = this.route.snapshot.queryParams['pax-View_session'];
        this.paxsessionid = sessionStorage.getItem('sessionId') ? this.apiService.getsessionId('sessionId'): this.paxsessionid;
      }
    this.checkOrientation();
  }


  public toggleSlidesPerView(): void {
    if (this.config.slidesPerView == 1) {
      this.config.slidesPerView = 1;
    } else {
      this.config.slidesPerView = 2;
    }
  }

  onIndexChange(event: any) {
    this.currentIndex = event;
  }


  public onSwiperEvent(event: string): void {
  }
  
  @HostListener ('window:focus', ['$event'])
  onFocus (event: any): void {
    this.isPortrait = window.innerHeight > window.innerWidth ? true : false
    if(!this.demo){
      window.location.reload()
      this.callingBoardingFlight();
    }
  }

  @HostListener('window:blur', ['$event'])
    onBlur(event: any): void {
    }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkOrientation();
    this.fromispotrait = true;
    this.paxsessionid = sessionStorage.getItem('sessionId') ? this.apiService.getsessionId('sessionId'): this.paxsessionid;
  }
  

  onSwipe(evt){
    const x = Math.abs(evt.deltaX) > 40 ? (evt.deltaX > 0 ? this.iseng = true : this.iseng = false) : '';
  }

  ngOnInit() {
    this.devicetype= sessionStorage.getItem('device');
    this.source = sessionStorage.getItem('source');
    this.medium = sessionStorage.getItem('medium');
    this.checkinternetissue()
    if(!this.gateslist){
      this.is_inpnrscreen = true;
      this.isPortrait = window.innerHeight > window.innerWidth ? true : false
      if(this.route.snapshot.queryParams['pax_view_session']){
        this.paxsessionid = this.route.snapshot.queryParams['pax_view_session'];
      }
        this.paxsessionid = sessionStorage.getItem('sessionId') ? this.apiService.getsessionId('sessionId'): this.paxsessionid;
      this.childData = JSON.parse(JSON.stringify(this.childData));
      const devicedetails = this.devicedetails.getDeviceInfo();
      const deviceres = window.innerHeight + '*' + window.innerWidth;
      const devicetype = this.devicedetails.isTablet() ? 'Tablet' : this.devicedetails.isMobile() ? 'Mobile' : this.devicedetails.isDesktop() ? 'Desktop' : 'Others';
      if(this.paxsessionid){
        const param = {
          pax_session_id: this.paxsessionid,
          browser_name : devicedetails.browser,
          browser_version: devicedetails.browser_version,
          device_name: devicedetails.device,
          os_name: devicedetails.os,
          os_version: devicedetails.os_version,
          device_type: devicetype,
          user_agent: devicedetails.userAgent,
          resolution: deviceres
        }
        if (window.performance.navigation.type === 1) {
          param['refresh'] = true;
        }
        this.apiService.verifyapi(param).subscribe(response=>{
          if(response){
            this.verifyqr = true;
            this.data = this.apiService.getSharedData();
            const qrparam = {
              data : this.weblink+'pax?gateno='+this.flightNo+'&source='+this.source+'&device='+this.devicetype+'&medium=qr'
            }
            this.apiService.getqrimage(qrparam).subscribe((resqr)=>{
              this.resqrimage = resqr.image;
              this.qrimage = "data:image/png;base64," + this.resqrimage;
              if(!this.data){
                this.calldata()
              }
              else if(this.data){
                this.thankingMsgCondition = false;
                this.dataarray = this.data[0];
                this.callapiwithlanguage()
              }
            })
            this.sendwatchcount();
            this.callwatchcount = interval(30000).subscribe(() => {
              this.sendwatchcount1();
            });
          }
        },(error)=>{
          this.router.navigate(['']);
          history.pushState(null, '','/');
          this.apiService.verifyapifailed.next(true)
        })
      }
      this.callapi = interval(30000).subscribe(() => {
        this.callingBoardingFlight();
      });
      if (this.countdownTimer) {
        this.countdownTimer.unsubscribe();
      }
      if (this.adTimer) {
        this.adTimer.unsubscribe();
      }
      this.etaExpand = false;
      this.boarding_msg = 'Boarding Started';
      this.gate_close = 0;
      this.adClose = false;
      this.spinner = false;
      this.adTimer;
      this.adSrc = '';
      this.adCounter = 1;
      this.countdowncount = 11;
      this.thanksImg = false;
      this.boardingStatus = false;
      this.countdownTimer = null;
      this.changeColor();
    }else{
      if(!this.dummygatevalue){
        const lang = {name: 'English',code:'En'}
        this.langconfig = lang.code == 'En' ? require("../../Language/En-us.json") : require("../../Language/It-us.json")
        this.ratingarray = this.langconfig.ratingarray
        this.apiService.language.next(lang)
        this.dataarray = this.gatesdata[this.index1].data
        this.childData = this.gatesdata[this.index1].childdata
        this.flightNo = this.gatesdata[this.index1].gate;
        this.qrimage = this.gatesdata[this.index1].qrimage;
      }else if(this.dummygatevalue){
        const lang = {name: 'English',code:'En'}
        this.langconfig = lang.code == 'En' ? require("../../Language/En-us.json") : require("../../Language/It-us.json")
        this.ratingarray = this.langconfig.ratingarray
        this.apiService.language.next(lang)
        this.dataarray = this.gatesdata.data
        this.childData = this.gatesdata.childdata
        this.flightNo = this.gatesdata.gate;
        this.qrimage = this.gatesdata.qrimage;
      }
      this.resqrimage = this.qrimage
      if(this.dataarray){
       this.startplayingtimer = timer(2000).subscribe(() => {
          this.startPlaying1(this.dataarray.front_camera);
        })
      }
    }
    this.typepreview = !this.dummygatevalue ? '../../../assets/images/live.svg': '../../../assets/images/preview.svg'
    
    this.qrimage = this.resqrimage ? "data:image/png;base64," + this.resqrimage : sessionStorage.getItem('qrimage') ? "data:image/png;base64," + sessionStorage.getItem('qrimage') : ''
    // }
    this.apiService.docclicked.next(true);
    this.apiService.docclicked.subscribe((res)=>{
      if(res == true){
        this.callinterval ? this.callinterval.unsubscribe() : null;
        if (this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId);
          if(!this.gateslist){
            // this.progressvalue = 90000;
            // this.timeoutId = setTimeout(() => {
            //   if (this.counter) {
            //     this.counter.reset();
            //   }
            // }, 10);
          }
        }
        if(!this.demo && !this.gateslist){
          this.calltimer();
        }
      }
    })
  }


  ondocclick(event:Event){
    this.ngOnDestroy();
    this.apiService.docclicked.next(true);
  }

  ngAfterViewInit(): void {
  }

  callapiwithlanguage(){
    this.apiService.language.subscribe((res)=>{
      this.langcode = res.code
      this.langconfig = this.langcode == 'En' ? require("../../Language/En-us.json") : require("../../Language/It-us.json")
      this.ratingarray = this.langconfig.ratingarray
      if(this.is_inpnrscreen){
        this.callingBoardingFlight();
        this.onStarClick(this.index, this.indexr);
      }else {
        return;
      }
      })
  }

  isOffline:boolean = false;
  private connectivitySubscription: Subscription;
  checkinternetissue(){
    this.apiService.isoffline.subscribe(status => {
      this.isOffline = status;
      if(!this.isOffline && !this.demo){
        this.callinterval ? this.callinterval.unsubscribe() : null;
        this.router.navigate(['']);
        this.apiService.showvideo.next(true);
        history.pushState(null, '', '/');
      }
    });
  }

  disclaimerclick(event){
    this.currentIndex = event;
    this.engdis = !this.engdis
  }

  onStarClick(index, indexr) {
    this.index = index;
    this.indexr = indexr;
    this.norating = false
    if(!this.norating){
      this.clicked = index;
      this.rating = index;
      this.ratingname = this.langconfig.ratingarray[indexr];
    }
    if(this.rating){
      this.ratingspinner = true;
      const param ={
        rating: this.rating,
        pax_session_id: this.paxsessionid,
        // comments: this.RatingComment
      }
      this.apiService.sendrating(param).subscribe(res=>{
        this.ratingsent = true;
        this.ratingspinner = false;
      },(error)=>{
        this.ratingspinner = false
      })
    }
  }

  setflightstatus(status) {
    if (status) {
      if(status.includes(',')){
        const statustextArray = status.split(',');
        const firstText = statustextArray[0];
        const secondText = statustextArray[1];
        return `${firstText} <br> ${secondText}`;
      } else {
        return status;
      }
    } else {
      return '-';
    }
  }  

  sendrating(){
    if(this.rating){
      this.ratingspinner = true;
      const param ={
        rating: this.rating,
        pax_session_id: this.paxsessionid,
        // comments: this.RatingComment
      }
      this.apiService.sendrating(param).subscribe(res=>{
        this.ratingsent = true;
        this.ratingspinner = false;
      },(error)=>{
        this.ratingspinner = false
      })
    }
  }


  gohome(){
    if(!this.demo){
      this.apiService.docclicked.next(false);
      this.demo = true;
      this.callinterval ? this.callinterval.unsubscribe() : null;
      this.apiService.showvideo.next(false);
      history.pushState(null, '', '/');
      this.router.navigate(['']);
    }
  }

  i = 0
  callinterval;
  calltimer(){
    if(!this.demo && !this.gateslist){
      this.apiService.showvideo.next(false);
      this.isDestroyed = false;
      this.nextgatevalue = 0;
      cancelAnimationFrame(this.animationFrameId);
      this.startProgress();
      this.progressvalue = 90000;
      this.timeoutId = timer(5).subscribe(() => {
        if(this.counter && this.isDestroyed == false){
          this.counter.reset();
        }
      })
      // this.incrementthevalue();
      if(!this.demo && !this.gateslist){
        this.callinterval = timer(90000).subscribe(() => {
          this.apiService.setbacktohome(true);
          this.apiService.showvideo.next(false);
          this.demo = true;
          history.pushState(null, '', '/');
          this.router.navigate(['']);
        });
      }
    }
  }

  openratings(){
    this.ref = this.dialog.open(this.ratingscomponent);
  }

  sendwatchcount(){
    if(this.paxsessionid){
      if (window.performance.navigation.type === 1) {
        this.refreshvalue = true;
      }
      const params ={
        pax_session_id :this.paxsessionid,
        view: !this.isPortrait ? 'Landscape' : 'Portrait',
        user_refresh: this.refreshvalue
      }
      this.apiService.watchcountapi(params).subscribe((res)=>{
        this.refreshvalue = false;
      })
    }
  }

  sendwatchcount1(){
    if(this.paxsessionid){
      const params ={
        pax_session_id :this.paxsessionid,
        view: !this.isPortrait ? 'Landscape' : 'Portrait',
        user_refresh: this.refreshvalue
      }
      this.apiService.watchcountapi(params).subscribe((res)=>{
        this.refreshvalue = false;
      })
    }
  }

  checkOrientation(): void {
    this.isPortrait = window.innerHeight > window.innerWidth ? true : false
    // const newIsPortrait = window.innerHeight > window.innerWidth;
    // if (newIsPortrait !== this.isPortrait) {
    //   this.isPortrait = newIsPortrait;
    //   // this.showOrientationPopup();
    // }
    // if(this.isPortrait){
      //  this.calldata();
    // }
    // this.sendwatchcount1()
  }

  calldata(){
      this.apiService.gates_api(this.flightNo).subscribe(response => {
        this.apiService.setSharedData(response.data);
        this.data = this.apiService.getSharedData();
        this.thankingMsgCondition = false;
          this.dataarray = this.data[0];
          this.callapiwithlanguage();
      })
  }

  closedialog(){
    this.ref.close();
  }

  admertisementclick(){
  //  window.open(
  //   "https://www.zestiot.com",
  //   "Independent Window",
  // );
}

videosrc;
Imagesrc;
  startPlaying() {
    this.apiService.getvideoconnection(this.dataarray.Id).subscribe(response => {
      if(response.status == 'finished' || response.status == 'error' || response.status == 'failed'){
        this.dataarray.front_camera = null;
      }else{
        if (!this.thankingMsgCondition && (this.dataarray && this.dataarray.front_camera)) {
          const embeddedPlayer = document.getElementById("embedded-player") as HTMLIFrameElement;
          if(embeddedPlayer){
            const dummyurl = this.dataarray.front_camera.replace('webrtc', 'hls')
            embeddedPlayer.src = this.dataarray.front_camera;
            const iframeDoc = embeddedPlayer.contentDocument || embeddedPlayer.contentWindow.document;
            const controls = iframeDoc.querySelectorAll('input, button, textarea, select');
            controls.forEach((control: HTMLElement) => {
              control.setAttribute('disabled', 'true');
            });
            function toggleFullScreen() {
              if (!document.fullscreenElement) {
                if (embeddedPlayer.requestFullscreen) {
                  embeddedPlayer.requestFullscreen().catch(err => {
                    console.error(`Error attempting to enable full-screen mode: ${err.message}`);
                  });
                }
              } else {
                if (document.exitFullscreen) {
                  document.exitFullscreen();
                }
              }
              embeddedPlayer.addEventListener("click", toggleFullScreen);
              embeddedPlayer.style.width = "100%";
              embeddedPlayer.style.height = "56.25vw";
            }
          }
        }
      }
    },(error)=>{
      this.dataarray.front_camera = null;
    })
  }


  Imagesource(){
    if(this.childData){
      if(this.childData.boarding_percentage >= 90 || (this.childData.status ==  'BOARDING MAY BE CLOSING'|| this.childData.status == "L'IMBARCO POTREBBE ESSERE IN CHIUSURA")){
        this.Imagesrc = '../../../assets/images/bmore90.webp'
        return this.Imagesrc
      }else if((this.childData.status == 'NO FLIGHT ASSIGNED TO THIS GATE'|| this.childData.status == "NESSUN VOLO ASSEGNATO A QUESTA GATE") || (this.childData.status ==  "NO INFORMATION AVAILABLE, PLEASE PROCEED TO YOUR GATE"|| this.childData.status == 'NESSUNA INFORMAZIONE DISPONIBILE, PROCEDERE AL VOSTRO GATE')){
        this.Imagesrc = '../../../assets/images/nof.webp'
        return this.Imagesrc
      }else if(this.childData.boarding_percentage < 90 && this.childData.boarding_percentage){
        this.Imagesrc = '../../../assets/images/bless90.webp'
        return this.Imagesrc
      }else if(!this.childData.boarding_percentage){
        this.Imagesrc = '../../../assets/images/nob.webp'
        return this.Imagesrc
      }
    }
  }

  linksetter;
  startPlaying1(link) {
    if (link) {
      const embeddedPlayer = document.getElementById("embedded-player"+this.index1) as HTMLIFrameElement;
      embeddedPlayer.src = link;
      const iframeDoc = embeddedPlayer.contentDocument || embeddedPlayer.contentWindow.document;
        const controls = iframeDoc.querySelectorAll('input, button, textarea, select');
        controls.forEach((control: HTMLElement) => {
          control.setAttribute('disabled', 'true');
        });
        this.linksetter = interval(30000).subscribe(() => {
          embeddedPlayer.src = link;
        });
      function toggleFullScreen() {
        if (!document.fullscreenElement) {
          if (embeddedPlayer.requestFullscreen) {
            embeddedPlayer.requestFullscreen().catch(err => {
              console.error(`Error attempting to enable full-screen mode: ${err.message}`);
            });
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
        embeddedPlayer.addEventListener("click", toggleFullScreen);
        embeddedPlayer.style.width = "100%";
        embeddedPlayer.style.height = "56.25vw";
      }

    }
  }

  currentCameraIndex: number = 0;
  camclicked() {
    if(!this.thankingMsgCondition && this.dataarray.left_camera || !this.thankingMsgCondition && this.dataarray.right_camera){
    const cameraUrls: string[] = [this.dataarray.front_camera];
    if (this.dataarray.left_camera) {
      cameraUrls.push(this.dataarray.left_camera);
    }
    if (this.dataarray.right_camera) {
      cameraUrls.push(this.dataarray.right_camera);
    }
    const embeddedPlayer = document.getElementById("embedded-player") as HTMLIFrameElement;
    if (embeddedPlayer) {
      this.currentCameraIndex = (this.currentCameraIndex + 1) % cameraUrls.length;
      embeddedPlayer.src = cameraUrls[this.currentCameraIndex];
      function toggleFullScreen() {
        if (!document.fullscreenElement) {
          if (embeddedPlayer.requestFullscreen) {
            embeddedPlayer.requestFullscreen().catch(err => {
              console.error(`Error attempting to enable full-screen mode: ${err.message}`);
            });
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
      }
  
      embeddedPlayer.addEventListener("click", toggleFullScreen);
  
      embeddedPlayer.style.width = "100%";
      embeddedPlayer.style.height = "56.25vw";
    } 
  }
  }  


  boardingtime;
  callingBoardingFlight() {
    if ((this.dataarray && this.dataarray.gate_no)) {
      let params = {}
        params = {
          gate: this.dataarray && this.dataarray.gate_no ? this.dataarray.gate_no : this.flightNo,
          // language: this.langcode
        }
      const langcode = this.langcode == 'En' ? 'en-US' : 'it-IT';
      this.apiService.adrInnerVideo(params, langcode).subscribe((res: any) => {
        if (res.data) {
          this.childData = {...this.childData, ...res.data};
          if(this.childData.boarding_pts){
            this.boardingtime = new Date(this.childData.boarding_pts);
          }
          const embeddedPlayer = document.getElementById("embedded-player") as HTMLIFrameElement;
          if(embeddedPlayer && !embeddedPlayer.src){
            this.startPlaying();
          }
          this.showclose = (this.childData.status == 'Boarding will start soon ' || this.childData.status == 'Gate not assigned to any flight ')? true : false;
          this.revertTimer(!this.childData.flightnodep,this.boardingtime);
          this.Showalert = this.childData.alert
          this.paxsessionid = this.apiService.getsessionId('sessionId');
          !this.paxsessionid ? this.apiService.verifyapifailed.next(true): '';
          !this.paxsessionid ? this.router.navigate(['']): '';
        }
      });
    }
  }

  navigateclick(){
    this.router.navigate(['/app/digital-twin'])
  }

  getLogoImage() {
    return this.childData.flight_code ? `assets/images/airlineLogos/${this.childData.flight_code}.png` : null;
  }

  onLoadFlightError(event: any) {
    this.imageFlightCode = false;
  }

  numberDigits(n: number) {
    return n > 9 ? '' + n : '0' + n;
  }

  timesetter;
  revertTimer(data: boolean, btime: any = null) {
    if (data && btime) {
      this.timesetter = interval(1000).subscribe(() => {
        this.timer.s -= 1;
        this.getDiffrence(btime);
      });
    }

    // this.mintimerHandler = setInterval(() => {
    //   this.mintimer.s -= 1;
    //   if (this.mintimer.s == 20) {
    //     this.thankingTimeCondition = true;
    //   }
    //   if (this.mintimer.s < 0) {
    //     // this.timer.s = 59;
    //     // this.timer.mn = -1;
    //     this.thankingTimeCondition = false;
    //     this.thankingMsgCondition = true;
    //     const aaa = document.getElementById('embedded-player') as HTMLIFrameElement;
    //     aaa.src = '';
    //     clearInterval(this.mintimerHandler);
    //   }
    // }, 1800);
  }

  getDiffrence(btime) {
    let dateNow: any = new Date(new Date().toLocaleString('en-US', {timeZone: '+0100'}))
    let dateFuture: any = new Date(btime.getFullYear() +1, 0, 1);

    let seconds = Math.floor((dateFuture - (dateNow))/1000);
    let minutes = Math.floor(seconds/60);
    let hours = Math.floor(minutes/60);
    let days = Math.floor(hours/24);

    hours = hours-(days*24);
    minutes = minutes-(days*24*60)-(hours*60);
    seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
    this.timer = {s: seconds, mn: minutes, hr: hours};
  }

  openSnackBar(message: string, action?: string) {
    this.snackBar.open(message, action, {
      panelClass: ['snackbar-background'],
      duration: 2000,
    });
  }

  changeColor() {
    this.childData.video_url = this.childData.video_url === this.childData.left_camera ? this.childData.right_camera : this.childData.left_camera;
  }

  getCardStyles(index: number) {
    return {
      'background-color': this.activeIndex === index ? '#3BB9B9' : 'darkgray'
    };
  }

  boardingStatus: boolean = false;

  countdownTimer: any;
  thanksImg: boolean = false;

  showThankyouSlide() {
    this.thanksImg = true;
  }

  ngOnDestroy() {
    this.is_inpnrscreen = false;
    if (this.adTimer) {
      this.adTimer.unsubscribe();
    }
    this.isDestroyed = true;
    if (this.timeoutId && this.isDestroyed) {
      this.timeoutId.unsubscribe();
    }
    if(this.startplayingtimer){
      this.startplayingtimer.unsubscribe();
    }
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    sessionStorage.removeItem('qrimage');
    this.callinterval ? this.callinterval.unsubscribe() : null;
    this.timesetter ? this.timesetter.unsubscribe(): null;
    this.linksetter ? this.linksetter.unsubscribe() : null;
    this.callapi ? this.callapi.unsubscribe() : null;
    this.callapi1 ? this.callapi1.unsubscribe() : null;
    this.callwatchcount ? this.callwatchcount.unsubscribe() : null;
    this.progresstimeout ? this.progresstimeout.unsubscribe() : null;
    this.progressvalueincrementer ? this.progressvalueincrementer.unsubscribe() : null;
  }

  renderPreBoarding() {
    this.boardingStatus = true;
    timer(15000).subscribe(() => {
      this.changeColor();
    });
  }
  progressvalue = 90000;
  progressvalueincrementer;
  // incrementthevalue(){
  //   this.progressvalueincrementer = setTimeout(() => {
  //     if(this.progressvalue >0){
  //       this.progressvalue--
  //       this.incrementthevalue();
  //     }else{
  //       this.progressvalue = 90
  //     }
  //   }, 1000); 
  // }

  animationFrameId: number;
  updateProgress;
  startProgress() {
    this.nextgatevalue = 0;
    const interval = 90000;
    let startTime: number;
    this.animationFrameId = null;
    // if(this.dummydatalength <= this.count){
      this.updateProgress = (currentTime: number) => {
        if (!startTime) {
          startTime = currentTime;
        }
        const elapsedTime = currentTime - startTime;
        if (elapsedTime >= interval) {
          this.nextgatevalue = 0;
          startTime = currentTime;
        } else {
          this.nextgatevalue = Math.floor((elapsedTime / interval) * 100);
        }
        // if (!this.isDestroyed) {
          this.animationFrameId = requestAnimationFrame(this.updateProgress);
        // }
      };
      requestAnimationFrame(this.updateProgress);
    // }
  }

  refresh() {
    this.camcahneg = !this.camcahneg;
    this.timer = {s: 72000, mn: 0, hr: 0};
    this.mintimer = {s: 72000, mn: 0, hr: 0};
    this.callingBoardingFlight();
    this.startPlaying();
  }

  onBack() {
    this.router.navigate(['/']);
  }
}
